
<template>
	<Menu
		ref="side_menu"
		theme="dark"
		:active-name="path"
		:open-names="[openNames]"
		width="200px"
		accordion
		@on-select="onselect"
		@on-open-change="openchange"
	>
		<template v-for="item in MenuList">
			<left-nav-children
				v-if="item.children && item.children.length !== 0"
				:parent-item="item"
			>
			</left-nav-children>
			<menu-item v-else :name="item.name">
				<Icon :type="item.icon" />
				<span>{{ item.title }}</span>
			</menu-item>
		</template>
	</Menu>
</template>
<script>
import leftNavChildren from '@/components/left_nav_children.vue';
export default {
	name: 'leftnav',
	components: {
		leftNavChildren
	},
	data() {
		return {
			path: '',
			openNames: '',
			menu: [
				{
					name: '',
					title: '总览',
					icon: ''
				},
				{
					name: '1',
					title: '个人中心',
					icon: '',
					children: [{
						title: '用户资料',
						icon: 'ios-disc-outline',
						name: 'UserInfo'
					},
					// {
					// 	title:'消息列表',
					// 	icon:'ios-chatboxes-outline',
					// 	name:'Message'
					// },
					{
						title: '供应商认证',
						icon: 'ios-chatboxes-outline',
						name: 'SupplierCert'
					}]
				}
				// ,{
				// 	name: '2',
				// 	title: '项目管理',
				// 	icon: '',
				// 	children:[{
				// 			title:'竞标项目',
				// 			icon:'',
				// 			name:'BiddingUserProject'
				// 		}]
				// },
				// {
				// 	name: '3',
				// 	title: '账务管理',
				// 	icon: '',
				// 	children:[{
				// 			title:'资金明细',
				// 			icon:'',
				// 			name:'CapitalDetail'
				// 		},
				// 		{
				// 			title:'   资金提现',
				// 			icon:'',
				// 			name:'CashWithApply'
				// 		}]
				// }
			],
			menu1: [
				{
					name: '',
					title: '总览',
					icon: ''
				},
				{
					name: '1',
					title: '个人中心',
					icon: '',
					children: [{
						title: '用户资料',
						icon: 'ios-disc-outline',
						name: 'UserInfo'
					}
					// 	, {
					// 	title: '消息列表',
					// 	icon: 'ios-chatboxes-outline',
					// 	name: 'Message'
					// }
					]
				},
				// {
				// 	name: '2',
				// 	title: '项目管理',
				// 	icon: '',
				// 	children: [{
				// 		title: '竞标项目',
				// 		icon: '',
				// 		name: 'BiddingProject'
				// 	}]
				// },
				{
					name: '3',
					title: '供应商管理',
					icon: '',
					children: [{
						title: '供应商列表',
						icon: '',
						name: 'Supplier'
					}]
				},
				// {
				// 	name: '4',
				// 	title: '财务管理',
				// 	icon: '',
				// 	children: [{
				// 		title: '资金明细',
				// 		icon: '',
				// 		name: 'CapitalDetail'
				// 	}, {
				// 		title: '提现审批',
				// 		icon: '',
				// 		name: 'CashWithDrawal'
				// 	}]
				// }
			],
			capacity: 1,//1.接包方，2发包方 3.管理员
			MenuList: []
		}
	},
	computed: {

	},
	created() {
		this.getNav()
	},
	watch: {
		$route(to, from) {
			if (to.params.text == '完善用户资料') {
				this.getNav()
			}
		}
	},
	methods: {
		getNav() {
			if (this.$getLS('AdminInfo')) {
				this.capacity = JSON.parse(this.$getLS('AdminInfo')).Type
			}
			if (this.capacity == 3 || this.capacity == 2) {//特殊身份登录
				this.MenuList = this.menu1
			} else {
				this.MenuList = this.menu;
			}
			this.path = this.$route.name;
			if (this.path == 'Message' || this.path == 'UserInfo' || this.path == 'SupplierCert') {//消息列表，用户资料，供应商认证
				this.openNames = '1';
			} else if (this.path == 'BiddingProject' || this.path == 'Supplier') {//竞标项目，供应商认证列表
				this.openNames = '2';
			} else if (this.path == 'CapitalDetail' || this.path == 'CashWithDrawal') {//资金明细，资金提现
				this.openNames = '3';
			} else if (this.path == "Overview") {
				this.path = '';
			}
			//别忘记更新菜单
			this.$nextTick(() => {
				this.$refs.side_menu.updateOpened()
				this.$refs.side_menu.updateActiveName()
			});
		},
		onselect(e) {
			if (e) {
				this.$router.push({ path: "/index" + '/' + e });
			} else {
				this.$router.push({ path: "/index" });
			}
		},
		openchange() {
			console.log(1212121)
		}

	}
}
</script>



// WEBPACK FOOTER //
// src/components/FatherNav.vue